import React, { useEffect, useState } from 'react'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export const ChoosePrice = ({setPrice, formattedPrice, price, error}) => {

  const defaultMaskOptions = {
    prefix: '',
    suffix: ' kr.',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 7, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: false,
  }

  const currencyMask = createNumberMask(defaultMaskOptions)
  
  return (
    <div className="relative w-full flex flex-col gap-2" id="setPrice">
      <div>
        <h2 className="text-sm font-medium text-gray-900">Vælg en pris for bogen</h2>
      </div>
      {(error !== '') ? <h2 className="text-sm font-medium text-gray-900 text-red-500">{error}</h2> : ""}
      <div className="w-full">
        <MaskedInput className="ring-1 ring-neutral-300 focus:ring-emerald-700 focus:ring-2 block w-full focus:outline-none p-4 ps-5 md:ps-10 text-sm text-gray-900" spellCheck="false" defaultValue={(formattedPrice !== 0 ? formattedPrice : "")} placeholder='0,00 kr.' onChange={(e) => setPrice(e.target.value)} mask={currencyMask} />
      </div>
      {(typeof price !== 'undefined' && price >= 5000) ?
        <div className="flex items-center gap-2">
          <h2 className=""><span className="font-semibold">BEMÆRK!</span> Du modtager <span className="font-medium">{((price/100)*0.95).toFixed(2).replace(/\./g, ',')} kr.</span> ved salg af denne bog</h2>
          <div className="flex group relative flex-wrap-reverse" tabindex="0">
            <div className="q-mark cursor-pointer group-focus:text-gray-500">
              <svg class="w-4 h-4 text-gray-400 hover:text-gray-500" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg><span class="sr-only">Show information</span>
            </div>
            <div className="">
              <div class="q-text right-0 invisible opacity-0 group-hover:visible group-hover:opacity-100 group-focus:visible group-focus:opacity-100 absolute bottom-[20px] z-10 w-64 text-sm transition-opacity duration-100 bg-white border border-gray-200 shadow-sm">
                <div class="px-3 py-2 bg-gray-100 border-b border-gray-200 rounded-t-lg">
                    <h3 class="font-semibold text-gray-900">Gebyr for salg</h3>
                </div>
                <div class="px-3 py-2 flex flex-col gap-2">
                  <p>Gebyr: <span className="font-semibold">5%</span> ({((price/100)*0.05).toFixed(2).replace(/\./g, ',')} kr.)</p>
                  <hr></hr>
                  <p>Ved salg trækkes der <span className="font-semibold">5%</span> af fortjensten, hvorefter det resterende beløb indsættes på din saldo</p>
                </div>
                <div data-popper-arrow></div>
              </div>
            </div>
          </div>
        </div>
      :
        ""
      }
    </div>
  )
}